'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;
var BfgLocationMap = require('./locationMap.js');

var SectionLocations = React.createClass({

    componentDidMount() {
        this.props.logPageView();
    },

    /**
     * @return {object}
     */
    render: function () {
        return (
            <section id="section3" className="content-section about-section sectionPage">
                <div className="row">
                    <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
                        <div className="title-v1">
                            <div className="row">
                                <div className="col-sm-12   col-xs-12">
                                    <h1 className="text-center"><FormatMessage locale={this.props.locale}
                                                                               path="locationsPage/locationsTitle"/>
                                    </h1>
                                    <hr className="small"/>
                                </div>
                                <div className="col-sm-10 col-xs-10 col-xs-offset-1">
                                    <p className="text-center"><FormatMessage locale={this.props.locale}
                                                                              path="locationsPage/locationsDescription1"/>
                                    </p>
                                </div>
                                <div className="col-sm-10 col-xs-10 col-xs-offset-1">
                                    <p className="text-center"><FormatMessage locale={this.props.locale}
                                                                              path="locationsPage/locationsDescription2"/><br/>
                                    </p>
                                </div>
                                <div className="col-sm-12 col-xs-12">
                                    <BfgLocationMap {...this.props} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
});


module.exports = SectionLocations



// WEBPACK FOOTER //
// ./js/sectionLocations.js